import IndividualNavbar from "../IndividualNavbar/IndividualNavbar";
import IndividualExtensionContent from "../IndividualExtensionContent/IndividualExtensionContent";
import styles from './IndividualExtensionPage.module.css';

export default function IndividualExtensionPage() {
    return (
        <div className={styles.container}>

            <section id="individualNavbar" data-testid="individualNavbar" >
                <IndividualNavbar />
            </section>

            <section id="individualExtensionContent" data-testid="individualExtensionContent" >
                <IndividualExtensionContent />
            </section>

        </div>
    );
}